"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const disposable_1 = require("./disposable");
class EventSource {
    /**
     * Waits for a single event.
     */
    waitOne() {
        return new Promise(resolve => this.one(resolve));
    }
}
exports.EventSource = EventSource;
class EventEmitter extends EventSource {
    constructor() {
        super(...arguments);
        this.subscriptions = new Set();
    }
    sub(fn) {
        const sub = {
            handler: fn,
            isOnce: false,
        };
        this.subscriptions.add(sub);
        return disposable_1.Disposable.create(() => this.subscriptions.delete(sub));
    }
    one(fn) {
        const sub = {
            handler: fn,
            isOnce: false,
        };
        this.subscriptions.add(sub);
        return disposable_1.Disposable.create(() => this.subscriptions.delete(sub));
    }
    asEvent() {
        return this;
    }
    emit(args, sender) {
        for (const sub of this.subscriptions.values()) {
            if (sub.isOnce) {
                this.subscriptions.delete(sub);
            }
            sub.handler(args, sender);
        }
    }
}
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=events.js.map